// Stores and retrieves a path to redirect to after the user completes auth.
//
// Used by ProtectedRoute / GuestOrProtectedRoute to remember which page an
// unauthenticated user originally tried to visit, so login / signup pages can
// send them back there once they're signed in. sessionStorage is used (rather
// than route state) because it survives full-page redirects through OAuth
// providers (Google, Apple) and through Supabase's auth callback.

const KEY = "mash:redirectAfterAuth";

// Routes we never want to bounce back to — landing/auth pages and other
// transient destinations. Keep this list narrow; anything app-internal is fair
// game.
const SKIP_PREFIXES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/auth",
];

export function rememberRedirectAfterAuth(path: string): void {
  if (!path || path === "/" || SKIP_PREFIXES.some(p => path.startsWith(p))) {
    return;
  }
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // sessionStorage can throw in private mode / SSR — non-fatal.
  }
}

export function consumeRedirectAfterAuth(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value) sessionStorage.removeItem(KEY);
    return value;
  } catch {
    return null;
  }
}
